import { autoserialize } from 'cerialize';

export class ItemMeta {
  @autoserialize createdByCaptain: boolean;
  @autoserialize itemId?: string;
  @autoserialize restricted: boolean;
  @autoserialize guaranteed: boolean;

  constructor(payload?: IItemMeta) {
    this.createdByCaptain = !!payload?.createdByCaptain;
    this.itemId = payload?.itemId;
    this.restricted = !!payload?.restricted;
    this.guaranteed = !!payload?.guaranteed;
  }
}

export interface IItemMeta {
  createdByCaptain?: boolean;
  itemId?: string;
  restricted?: boolean;
  guaranteed?: boolean;
  price?: number;
  sell_rate?: number;
}
